import { Directive, ElementRef, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  selector: 'input, select, textarea, mat-radio-button, mat-checkbox, mat-slide-toggle, mat-select, mat-button-toggle, mat-slider, [contenteditable="true"]'
})
export class FormElementClassDirective implements AfterViewInit {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    const element = this.el.nativeElement;
    console.log('FormElementClassDirective applied to:', element);
    
    // For Material components, find the native input/button inside
    if (element.tagName.toLowerCase().startsWith('mat-')) {
      // Wait for Material to render its internal structure
      setTimeout(() => {
        // Find native input elements inside Material components
        const nativeInput = element.querySelector('input, button, textarea');
        if (nativeInput) {
          console.log('Found native element inside Material component:', nativeInput);
          this.renderer.addClass(nativeInput, 'mf-masked');
          this.renderer.addClass(nativeInput, 'mf-listen');
        } else {
          // If no native input found, apply to the host element
          this.renderer.addClass(element, 'mf-masked');
          this.renderer.addClass(element, 'mf-listen');
        }
      }, 0);
    } else {
      // For regular HTML elements, apply directly
      this.renderer.addClass(element, 'mf-masked');
      this.renderer.addClass(element, 'mf-listen');
    }
  }
}